import { makeStyles } from "@fluentui/react-components";
import { NHColors } from "utils/generalUtils";

export const H1_TEXT: "b" | "em" | "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "i" | "p" | "pre" | "span" | "strong" | undefined = "h1";

export const useStyles = makeStyles({
    wrapper: {
        height: '100vh',
        width: '100vw',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        rowGap: '2rem',
        textAlign: 'center',
        backgroundColor: '#f8f8f8'
    },
    code: {
        fontSize: '6rem',
        lineHeight: 1,
        fontWeight: 800,
        color: '#666'
    },
    button: {
        background: NHColors.primary
    }
});